import { EnvironmentConfigurer } from "./EnvironmentConfigurer";
import { Environment } from "./Environment";

export const getEnvironment = (): Environment => {
  return EnvironmentConfigurer.getEnvironment();
};
